import * as Sentry from '@sentry/react'
import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

function FallbackUI() {
  const { t } = useTranslation('errors')
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <AlertTriangle className="mx-auto h-12 w-12 text-yellow-500" />
        <h1 className="mt-4 text-2xl font-bold text-gray-900">
          {t('boundary.title')}
        </h1>
        <p className="mt-2 text-gray-600">
          {t('boundary.description')}
        </p>
        <Button
          className="mt-6"
          onClick={() => window.location.reload()}
        >
          {t('boundary.retry')}
        </Button>
      </div>
    </div>
  )
}

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
